import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AdminContext } from '../context/AdminContext';

function AdminProtectedRoute({ children }) {
    const { isAdmin, adminLoading } = useContext(AdminContext);
    const location = useLocation();

    // 1. Wait for the backend validation to finish
    if (adminLoading) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFF5EE]">
                <div className="w-12 h-12 border-4 border-[#dbcdac] border-t-[#971253] rounded-full animate-spin"></div>
                <p className="mt-4 text-[#971253] font-serif animate-pulse">Verificando credenciais...</p>
            </div>
        );
    }

    // 2. Protect the route if validation failed/returned false
    if (!isAdmin) {
        return <Navigate to="/admin-login" state={{ from: location }} replace />;
    }

    // 3. Render the secure component
    return children;
}

export default AdminProtectedRoute;